export default "/kiban/_next/static/images/top_black-d32e6c99845db857a1cc454a772de2d6.png";